
import { Component, Vue, Prop } from 'nuxt-property-decorator';
import Tooltip from './Tooltip.vue';

@Component({
  components: {
    Tooltip,
  },
})
export default class Hint extends Vue {
  @Prop({ type: String, default: '' }) readonly content!: string;
  @Prop({ type: String, default: undefined }) readonly placement!: string;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
}
